import styled from 'styled-components';
import { Input, Row, Label } from 'reactstrap';
import { Button } from '@shoflo/polymer';

export const StyledAnimationStyleInput = styled(Input)`
  height: 50px;
`;

export const AutoLeaveWrapper = styled.div`
  label {
    margin-top: 2px;
  }

  div {
    color: #6e7582;
    font-size: 12px;
    line-height: 16px;
  }
`;

export const ToggleSwitchWrapper = styled.span`
  span {
    top: 10px;
  }
`;

export const StyledRow = styled(Row)`
  opacity: 50%;
`;

export const StyledLabel = styled(Label)`
  font-size: 14px;
  font-weight: 500;
`;

export const StyledButton = styled(Button)`
  border: 1px solid #dfe3ec;
`;

export const StyledCancelButton = styled(Button)`
  color: #000000 !important;
  background-color: #ffffff !important;

  &:hover,
  &:active {
    box-shadow: none !important;
  }
  &:focus {
    box-shadow: none !important;
  }
`;
